import { render, staticRenderFns } from "./add-custom-tracking-domain-dialog.vue?vue&type=template&id=edf7b67a&scoped=true&"
import script from "./add-custom-tracking-domain-dialog.vue?vue&type=script&lang=ts&"
export * from "./add-custom-tracking-domain-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./add-custom-tracking-domain-dialog.vue?vue&type=style&index=0&id=edf7b67a&lang=scss&scoped=true&"
import style1 from "./add-custom-tracking-domain-dialog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf7b67a",
  null
  
)

export default component.exports